import React from 'react'
import useReduxState from 'src/hooks/useReduxState';
import QuoteDetail from '@system/config/quote';
import { __remove, __set } from 'src/store/axios_indicator'; 
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const ClearQuoteCart = props => {
    const [quoteList, setQuoteList] = useReduxState({}, 'QuoteCartList')
    const { data: { clearAllCart = false, currentCartItem = {} }, SetStatus } = props
      const [__check] = useAxiosIndicatorCheck();

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const clearQuoteCart = () => {
        sessionStorage.removeItem('QUOTE_CART_LIST')
        setQuoteList([])
        __set('CLEAR_QUOTE_CART_ITEM')
        window.location.href = QuoteDetail.getQuoteDetailPageRouteURL({ quote_number: currentCartItem?.quoteNumber })
        SetStatus(false)
        __remove('CLEAR_QUOTE_CART_ITEM')
    }

    const clearSingleQuoteItem = () => {
        const removeItem = quoteList?.filter(ele => ele?.ItemNumber !== currentCartItem?.ItemNumber)
        sessionStorage.setItem('QUOTE_CART_LIST', JSON.stringify(removeItem))
        setQuoteList(removeItem)
        __set('CLEAR_QUOTE_CART_ITEM')
        if (quoteList?.length === 1) {
            window.location.href = QuoteDetail.getQuoteDetailPageRouteURL({ quote_number: currentCartItem?.quoteNumber })
        }
        SetStatus(false)
        __remove('CLEAR_QUOTE_CART_ITEM')
    }

    return (
        <div className="avnet-modal modal-630">
            <div className="avnet-modal-inner">
                {/* Modal Header */}
                <button type="button" className="close py-3" data-dismiss="modal"
                    onClick={onHide}>×</button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading pl-5">{clearAllCart ? 'Cart - Clear All' : 'Clear Quote Item'}</h3>
                </div>
                {/* Modal body */}
                <div className="modal-body">
                    <div className="clearfix" />
                    <div className="text-center mt-3 mb-5">
                        <p className="mb-0">{clearAllCart ? 'Clearing your cart is permanent. All items will be removed and is not reversible.' : 'Once cleared you will remove this item from your Quote cart.'}</p>
                    </div>
                </div>
                {/* Modal footer */}
                <div className="modal-footer text-center">
                    <div className="modal-footer-actions">
                        <button type="button" className="bs5 btn btn-secondary btn-sm" data-dismiss="modal"
                            disabled={__check(['CLEAR_QUOTE_CART_ITEM']).status}
                            onClick={onHide}>
                            Cancel
                        </button>
                        <button
                            onClick={() => clearAllCart ? clearQuoteCart() : clearSingleQuoteItem()}
                            disabled={__check(['CLEAR_QUOTE_CART_ITEM']).status}
                            type="button" className="bs5 btn btn-primary btn-sm w145">
                            {__check(['CLEAR_QUOTE_CART_ITEM']).status ? <i className="fa fa-spinner fa-spin" /> : clearAllCart ? 'continue' : 'clear'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClearQuoteCart